import { Subject } from "./Subject.js";
import { Subscription } from "./Subscription.js";
class ReplaySubject extends Subject {
  // Removed: private _error: E | undefined;
  // Removed: private _isStopped = false;
  constructor(bufferSize = Infinity) {
    super();
    this.bufferSize = bufferSize;
    this._buffer = [];
  }
  next(data) {
    if (this._isStopped) {
      return;
    }
    this._buffer.push(data);
    if (this._buffer.length > this.bufferSize) {
      this._buffer.shift();
    }
    super.next(data);
  }
  error(err) {
    super.error(err);
  }
  complete() {
    super.complete();
  }
  _subscribeToSubject(subscriber) {
    this._buffer.forEach((value) => subscriber.next(value));
    if (this._isStopped) {
      if (this._hasError) {
        subscriber.error(this._error);
      } else {
        subscriber.complete();
      }
      return Subscription.EMPTY;
    }
    return super._subscribeToSubject(subscriber);
  }
}
export {
  ReplaySubject
};
//# sourceMappingURL=ReplaySubject.js.map
